module.exports = __webpack_public_path__ + "media/images/placeholder-logo-c7fa30c0.png";